import React from "react";
import { Link, withRouter } from "react-router-dom";
import logoWhite from "../../assets/images/smartdrive-logo-white.png";
import logoBlack from "../../assets/images/smartdrive-logo-black.png";
import navbarTogglerWhite from "../../assets/images/navbar-toggle-white-icon.png";
import navbarTogglerGreen from "../../assets/images/navbar-toggle-green-icon.png";

const Navbar = props => {
  const path = props.location.pathname;
  return (
    <nav
      className={`navbar navbar-default navbar-fixed navbar-expand-lg ${
        path === "/" ? "navbar-home" : "navbar-light bg-light"
      }`}
    >
      <Link to="/">
        <img src={path === "/" ? logoWhite : logoBlack } alt="Logo" />
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span className="navbar-toggle">
          <img src={path === "/" ? navbarTogglerWhite : navbarTogglerGreen} alt="Navbar Toggler Icon" />
        </span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav ml-auto fs-15">
          <li className="nav-item mr-5">
            <Link to="/about" className="nav-link font-weight-bold">
              About us
            </Link>
          </li>
          <li className="nav-item mr-5">
            <Link to="/culture" className="nav-link font-weight-bold">
              Culture
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/careers" className="nav-link font-weight-bold">
              Careers
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default withRouter(Navbar);
